
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetokohlapurinnovacrystacabservice() {



    const cardData =
    {
        keyword: 'Pune to Kolhapur Innova Crysta Cab Service',
        heading: 'Meghana Cab : Pune to Kolhapur Innova Crysta Cab Service',
        headingDescription: 'Meghana Cab offers Pune to Kolhapur Innova Crysta Cab Service, delivering a premium, spacious, and comfortable travel experience for families, groups, and corporate travelers. Covering approximately 230–240 km with a journey time of about 5 hours, our Innova Crysta vehicles feature plush leather interiors, ample legroom, generous luggage capacity, air-conditioning, and top safety features—ideal for a smooth highway drive along the Mumbai–Pune Expressway and NH 48 . Whether traveling for leisure, business, or pilgrimage, Meghana Cab ensures professional chauffeurs, door-to-door pickups from anywhere in Pune, GPS-enabled cabs, and 24/7 customer support. Book your Pune to Kolhapur Innova Crysta Cab with Meghana Cab for a luxurious, reliable, and stress-free journey—where comfort meets convenience every mile of the way.',


        top: 'Top Places to Visit in Kolhapur with Meghana Cab',

"topPlaces": [
  {
    "title": "Mahalakshmi Temple",
    "description": "One of India’s most revered Shakti Peethas, this 7th-century Hemadpanti-style temple is dedicated to Goddess Mahalakshmi. The black-stone idol (Ambabai) weighs ~40 kg and attracts devotees year-round, especially during Kirnotsav and Navratri. The majestic architecture and spiritual ambiance make it Kolhapur’s heart and soul."  
  },
  {
    "title": "Rankala Lake & Shalini Palace",
    "description": "Rankala is a historic lake formed in the 9th century, surrounded by lakeside gardens, horse-riding tracks, boating, and a fresh food market. On its western bank stands the Indo-Saracenic Shalini Palace (built 1931–34), once a royal retreat and now a lakeside landmark with marble arches and tranquil gardens."  
  },
  {
    "title": "New Palace (Chatrapati Shahu Museum)",
    "description": "Constructed in black basalt and red sandstone between 1877–84, this octagonal palace houses the Shahu Museum, showcasing royal memorabilia—costumes, weapons, trophies, stuffed wildlife—and ornate Darbar Hall with stained glass scenes from Shivaji’s life. A regal journey into Kolhapur's heritage."  
  },
  {
    "title": "Panhala Fort",
    "description": "About 20 km from the city, this sprawling 12th-century hill fort offers zigzag ramparts, hidden wells (Andhar Bavadi), majestic Teen Darwaza gateway, and rich Maratha-era history—including the Battle of Pavan Khind and Mughal-Maratha sieges. Panoramic Sahyadri views await at every turn."  
  },
  {
    "title": "Panhala – Jyotiba Temple",
    "description": "Perched atop a hill at ~3,100 ft and ~18 km from Kolhapur, this vibrant Shakti-Peetha complex draws devotees in thousands during Chaitra and Kartiki Pournima. Apart from spiritual appeal, the site offers sweeping valley views and a traditional pilgrimage experience."  
  },
  {
    "title": "Koteshwar Temple",
    "description": "A serene riverside Shiva temple on the banks of the Krishna River, renowned for its calm ambience and exquisite carvings. The nearby forested setting and sacred sanctity make it a peaceful site for devotees and seekers of solitude."  
  },
  {
    "title": "Kopeshwar Temple (Khidrapur)",
    "description": "A remarkable 12th-century Shiva temple built by the Shilahara dynasty, located ~15 km from town. Known for its conical sanctum and finely carved stone sculptures, it's an architectural gem of Kolhapur’s ancient heritage."  
  },
  {
    "title": "Bhavani Mandap & Khasbag Maidan",
    "description": "Situated near Mahalakshmi Temple, the historical Bhavani Mandap hosts statues, ancient pillared halls, and cultural events. Adjacent, Khasbag Maidan is a sprawling ground where traditional wrestling (kushti) is still practiced amid local celebrations."  
  },
  {
    "title": "Dajipur (Radhanagari) Wildlife Sanctuary",
    "description": "About 45 km from Kolhapur, this protected sanctuary was Maharashtra’s first wildlife reserve. Home to Indian bison (gaur), leopards, sloth bears, and over 150 bird species, it lies within the biodiverse Western Ghats and offers safari drives in a lush, eco-sensitive terrain."  
  },
  {
    "title": "Chambukadi & Pachgaon Hills",
    "description": "Local favorite hilltops within city limits, ideal for short treks and golden-hour views. Chambukadi Tekdi and Pachgaon Tekdi offer panoramic city vistas and are beloved by Pune locals for evening walks and skyline photography."  
  }
],

       "services": [
    {
      "name": "Pune to Kolhapur Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab from Pune to Kolhapur for a safe, comfortable, and hassle-free journey. Our cabs are equipped with spacious interiors, air conditioning, and professional chauffeurs to ensure a smooth ride through NH48, ideal for business or leisure travel."
    },
    {
      "name": "One Way Innova Crysta Pune Kolhapur",
      "description": "Looking for a one-way drop from Pune to Kolhapur? Our one-way Innova Crysta cab service offers affordability and comfort, with clean, chauffeur-driven SUVs that ensure a relaxed 5-6 hour journey without return obligations."
    },
    {
      "name": "Round Trip Innova Crysta Pune Kolhapur",
      "description": "Choose our round-trip Innova Crysta cab package for a convenient Pune to Kolhapur travel plan. Ideal for family visits, temple darshan at Mahalaxmi, or corporate day trips, our cabs stay with you throughout the day and return at your convenience."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Kolhapur",
      "description": "Travel in total comfort with our air-conditioned Innova Crysta taxis. Ideal for Pune to Kolhapur trips, our AC cabs provide relief from heat, noise, and road fatigue during your 230+ km journey."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Kolhapur",
      "description": "Enjoy the ride as our well-trained, courteous drivers handle the Pune-Kolhapur highway with ease. Chauffeur-driven Innova Crystas offer punctual service, route expertise, and a stress-free experience for families, tourists, or executives."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Kolhapur",
      "description": "Opt for a private Innova Crysta taxi to Kolhapur from Pune and enjoy total privacy and comfort. No shared rides—just a dedicated vehicle tailored to your schedule and needs."
    },
    {
      "name": "Online Booking Innova Crysta Pune Kolhapur",
      "description": "Book your Pune to Kolhapur Innova Crysta taxi online in minutes. Get instant confirmation, transparent pricing, and multiple pickup options—all through our secure booking platform."
    },
    {
      "name": "Kolhapur Tour Innova Crysta",
      "description": "Explore Kolhapur's heritage sites, temples, and local cuisine with our full-day Innova Crysta tour package. Perfect for small groups or families, the cab stays at your disposal throughout the day for flexible sightseeing."
    },
    {
      "name": "Business Trip Cab Pune Kolhapur",
      "description": "Heading to Kolhapur for business? Our Innova Crysta cabs offer executive comfort, punctual service, and enough room for team members or equipment. Ideal for corporate events or site visits."
    },
    {
      "name": "Family Travel Innova Crysta Kolhapur",
      "description": "Make your family trip from Pune to Kolhapur memorable with a spacious Innova Crysta. With ample boot space and comfortable seating, it’s perfect for kids, elders, and luggage-heavy journeys."
    },
    {
      "name": "Comfortable Innova Crysta Taxi Pune Kolhapur",
      "description": "Experience the best in-class comfort on your Pune-Kolhapur journey. Our Innova Crysta taxis come with reclining seats, suspension designed for long drives, and smooth highway handling."
    },
    {
      "name": "Reliable Cab Service Pune Kolhapur",
      "description": "Depend on our reliable cab service for timely pickups, route safety, and verified drivers. Our Pune to Kolhapur Innova Crysta fleet is maintained to deliver consistent quality on every trip."
    },
    {
      "name": "Budget Innova Crysta Taxi Pune Kolhapur",
      "description": "Travel affordably in style. Our budget Innova Crysta cab options let you enjoy premium travel features without breaking your wallet—perfect for solo travelers or cost-conscious groups."
    },
    {
      "name": "Premium Innova Crysta Cab Hire Kolhapur",
      "description": "Upgrade your road travel experience with our premium Innova Crysta cab hire to Kolhapur. Enjoy a plush interior, USB charging, music systems, and smooth suspension for luxury on wheels."
    },
    {
      "name": "Long Distance Innova Crysta Pune Kolhapur",
      "description": "For long-distance travelers, our Innova Crysta cabs from Pune to Kolhapur offer optimal comfort, spacious seating, and a fatigue-free journey over 5+ hours of highway travel."
    }
  ],
  "tableData": [
    ["Pune to Kolhapur Innova Crysta Cab Booking", "One Way Innova Crysta Pune Kolhapur"],
    ["Round Trip Innova Crysta Pune Kolhapur", "AC Innova Crysta Taxi Pune Kolhapur"],
    ["Chauffeur Driven Innova Crysta Pune Kolhapur", "Private Innova Crysta Taxi Pune Kolhapur"],
    ["Online Booking Innova Crysta Pune Kolhapur", "Kolhapur Tour Innova Crysta"],
    ["Business Trip Cab Pune Kolhapur", "Family Travel Innova Crysta Kolhapur"],
    ["Comfortable Innova Crysta Taxi Pune Kolhapur", "Reliable Cab Service Pune Kolhapur"],
    ["Budget Innova Crysta Taxi Pune Kolhapur", "Premium Innova Crysta Cab Hire Kolhapur"],
    ["Long Distance Innova Crysta Pune Kolhapur", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Premium Innova Crysta Cab from Pune to Kolhapur",
    "WhyChoosedescription": "Book our Innova Crysta for a smooth and relaxing journey from Pune to Kolhapur. Perfect for temple visits, business travel, or family trips, our cab service ensures comfort, safety, and punctuality over the 230+ km route."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Long-Distance Ride",
    "WhyChoosedescription": "With seating for up to 6–7 passengers, plush interiors, rear AC vents, and ample luggage room, the Innova Crysta offers unmatched comfort for highway travel. Ideal for families, senior citizens, or group travelers heading to Kolhapur."
  },
  {
    "WhyChooseheading": "Professional Drivers with Route Expertise",
    "WhyChoosedescription": "Our experienced chauffeurs are familiar with the Pune–Satara–Kolhapur highway. They ensure a safe and timely trip, accommodating rest breaks and assisting with luggage, route changes, or pickup/drop coordination as needed."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "All our Innova Crysta cabs are thoroughly cleaned and sanitized before each ride. Regular maintenance ensures a reliable vehicle with top-notch performance, safety, and comfort—ideal for long-distance travel."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Our fares include fuel, tolls, driver charges, and taxes. No hidden fees—just a fair, competitive price for a premium ride. Get upfront quotes and enjoy stress-free billing every time."
  },
  {
    "WhyChooseheading": "Flexible Booking – One-Way or Round Trip Options",
    "WhyChoosedescription": "We offer both one-way and round-trip cab services from Pune to Kolhapur. Whether you're visiting the Mahalaxmi Temple, attending a function, or returning the same day, we tailor the ride to your schedule."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimage, Family Functions, and Business Travel",
    "WhyChoosedescription": "Kolhapur is a key destination for spiritual, cultural, and business reasons. Our Innova Crysta service caters to all traveler types—families, working professionals, and tourists—offering reliable and stylish travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Easy Booking",
    "WhyChoosedescription": "Book your cab any time with our round-the-clock customer service. Our team is always ready to help with booking queries, changes, or last-minute travel needs, ensuring a seamless journey experience."
  }
]

















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta cab from Pune to Kolhapur?",
        answer: "You can book easily by calling Meghana Cab at +91 9075462128 or through our website for instant confirmation."
    },
    {
        question: "What is the distance and travel time from Pune to Kolhapur?",
        answer: "The distance is approximately 235 km, and the journey takes around 4.5 to 5.5 hours depending on traffic."
    },
    {
        question: "Is Innova Crysta a good vehicle for Pune to Kolhapur travel?",
        answer: "Yes, the Innova Crysta is ideal for long journeys with its spacious seating, powerful performance, and comfort."
    },
    {
        question: "Can I book the cab for a one-way or round trip?",
        answer: "Yes, we offer flexible options including both one-way and round-trip bookings."
    },
    {
        question: "How many people can travel in the Innova Crysta?",
        answer: "It comfortably seats 6 to 7 passengers along with luggage."
    },
    {
        question: "Are Meghana Cab’s vehicles sanitized before each trip?",
        answer: "Yes, we sanitize every vehicle before every ride to ensure safety and cleanliness."
    },
    {
        question: "Does the fare include tolls and driver allowance?",
        answer: "Yes, the quoted fare includes driver charges, fuel, and tolls. Parking or extra wait time may be charged separately."
    },
    {
        question: "Can I request sightseeing or meal stops en route?",
        answer: "Yes, you can request custom stops. Please mention them during booking for a tailored experience."
    },
    {
        question: "Is the service available 24/7 from Pune to Kolhapur?",
        answer: "Yes, we operate round the clock to meet your travel needs at any hour."
    },
    {
        question: "What are the payment options for this service?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ajay Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Took the Innova Crysta from Pune to Kolhapur. Very comfortable, timely pickup, and professional service from Meghana Cab.”',
    },
    {
        name: 'Ms. Rutuja Kamble',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly satisfied with the ride to Kolhapur. The vehicle was clean and the driver was courteous and skilled.”',
    },
];




























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const puneKolhapurInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Kolhapur Innova Crysta Cab Service",
  "description": "Reliable and comfortable Innova Crysta taxi service from Pune to Kolhapur. Perfect for business trips, family travel, sightseeing tours, and long-distance rides with chauffeur-driven premium cabs.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Kolhapur"
    }
  ],
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-kolhapur-innova-crysta-cab"
  }
};









    return (
        <div>

<Helmet>
  <title>Pune to Kolhapur Innova Crysta Cab Service | Reliable Taxi Booking</title>
  <meta
    name="description"
    content="Book Innova Crysta cabs from Pune to Kolhapur for business, family trips, and long-distance travel. Affordable, comfortable, and chauffeur-driven taxi service."
  />
  <meta
    name="keywords"
    content="Pune to Kolhapur Innova Crysta Cab Booking, One Way Innova Crysta Pune Kolhapur, Round Trip Innova Crysta Pune Kolhapur, AC Innova Crysta Taxi Pune Kolhapur, Chauffeur Driven Innova Crysta Pune Kolhapur, Private Innova Crysta Taxi Pune Kolhapur, Online Booking Innova Crysta Pune Kolhapur, Kolhapur Tour Innova Crysta, Business Trip Cab Pune Kolhapur, Family Travel Innova Crysta Kolhapur, Comfortable Innova Crysta Taxi Pune Kolhapur, Reliable Cab Service Pune Kolhapur, Budget Innova Crysta Taxi Pune Kolhapur, Premium Innova Crysta Cab Hire Kolhapur, Long Distance Innova Crysta Pune Kolhapur"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneKolhapurInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetokohlapurinnovacrystacabservice;